import { gEnums } from "../../../global/enums/globalEnums";
import { listList } from "../../../global/lists/lists";
import { settingsHelpers } from "../../../global/viewSettings/helpers/settingsHelpers";
import { propDataOpts, propDefaults } from "../../../global/viewSettings/settingsProps/settingsAll";

const golfPropTypes = Object.freeze({
  handicapSourceType: 'handicapSourceType',
  handicapIndex: 'handicapIndex',
  tournamentHandicapIndex: 'tournamentHandicapIndex',
  phoneNumber: 'phoneNumber',
  email: 'email',
  firstName: 'firstName',
  lastName: 'lastName',
  name: 'name',
});

export const _golfFormTypes = Object.freeze({
  courseHandicap: 'courseHandicap',
  golfer: 'golfer',
  handicapIndex: 'handicapIndex',
  tournamentHandicapIndex: 'tournamentHandicapIndex',
})

export const golfPropAllows = (propAllows) => {
  const items = {}
  _.forEach(propAllows, (propAllow, paKey) => {
    switch (paKey) {
      case 'matchCubeType':
        items[paKey] = settingsHelpers.newPropObject(paKey, propDataOpts(false, gEnums.formItemTypes.select, null, { trueList: listList(matchCubeTypes) }))
        break;
      default:
        items[paKey] = settingsHelpers.newPropObject(paKey, propDataOpts(false, gEnums.formItemTypes.checkbox))
    }
  })
  return items
}

export const golfAppForms = () => {

  // const baseFields = {
  //   handicapSourceType: settingsHelpers.newPropObject(
  //     golfPropTypes.handicapSourceType,
  //     propDataOpts(true, gEnums.formItemTypes.select, null, { trueList: listList(hcpSourceTypes) })
  //   ),
  //   handicapIndex: settingsHelpers.newPropObject(
  //     golfPropTypes.handicapIndex,
  //     propDataOpts(true, gEnums.formItemTypes.select, null, { ...propDefaults(10, 0, 36, null, .1).numbers })
  //   ),
  //   tournamentHandicapIndex: settingsHelpers.newPropObject(
  //     golfPropTypes.tournamentHandicapIndex,
  //     propDataOpts(true, gEnums.formItemTypes.select, null, { ...propDefaults(10, 0, 36, null, .1).numbers })
  //   )
  // };

  return {
    handicapIndex: {
      // ...baseFields,
      handicapSourceType: settingsHelpers.newPropObject(golfPropTypes.handicapSourceType, propDataOpts(true, gEnums.formItemTypes.select, null, { trueList: listList(hcpSourceTypes) })),
      handicapIndex: settingsHelpers.newPropObject('handicapIndex', propDataOpts(true, gEnums.formItemTypes.select, null, { ...propDefaults(10, 0, 36, null, .1).numbers })),
      phoneNumber: settingsHelpers.newPropObject('phoneNumber', propDataOpts(true, gEnums.formItemTypes.phoneNumber)),
      email: settingsHelpers.newPropObject('email', propDataOpts(true, gEnums.formItemTypes.email)),
    },
    tournamentHandicapIndex: {
      // ...baseFields,
      handicapSourceType: settingsHelpers.newPropObject('handicapSourceType', propDataOpts(false, gEnums.formItemTypes.textReadOnly)),
      handicapIndex: settingsHelpers.newPropObject('handicapIndex', propDataOpts(false, gEnums.formItemTypes.textReadOnly)),
      tournamentHandicapIndex: settingsHelpers.newPropObject('tournamentHandicapIndex', propDataOpts(true, gEnums.formItemTypes.select, null, { ...propDefaults(10, 0, 36, null, .1).numbers })),
      allowLineupModification: settingsHelpers.newPropObject('allowLineupModification', propDataOpts(false, gEnums.formItemTypes.checkbox)),
    },
    courseHandicap: {
      // ...baseFields,
      handicapIndex: settingsHelpers.newPropObject('handicapIndex', propDataOpts(false, gEnums.formItemTypes.textReadOnly)),
      handicapSourceType: settingsHelpers.newPropObject('handicapSourceType', propDataOpts(false, gEnums.formItemTypes.textReadOnly)),
      tournamentHandicapIndex: settingsHelpers.newPropObject('tournamentHandicapIndex', propDataOpts(true, gEnums.formItemTypes.textReadOnly)),
    },
    golfer: {
      firstName: settingsHelpers.newPropObject('firstName', propDataOpts(false, gEnums.formItemTypes.text)),
      lastName: settingsHelpers.newPropObject('lastName', propDataOpts(false, gEnums.formItemTypes.text)),
      email: settingsHelpers.newPropObject('email', propDataOpts(true, gEnums.formItemTypes.email)),
      phoneNumber: settingsHelpers.newPropObject('phoneNumber', propDataOpts(false, gEnums.formItemTypes.phoneNumber)),
      handicapIndex: settingsHelpers.newPropObject('handicapIndex', propDataOpts(true, gEnums.formItemTypes.select, null, { ...propDefaults(10, 0, 36, null, .1).numbers })),
      handicapSourceType: settingsHelpers.newPropObject('handicapSourceType', propDataOpts(true, gEnums.formItemTypes.select, null, { trueList: listList(hcpSourceTypes) })),
    },
    golfCourseTeeBox: {
      name: settingsHelpers.newPropObject('name', propDataOpts(false, gEnums.formItemTypes.text)),
    }
  }
}

export const matchCubeTypes = Object.freeze({
  alt: 'alt',
  normal: 'normal',
})

export const hcpSourceTypes = Object.freeze({
  diablo: 'diablo',
  garmin: 'garmin',
  golfPad: 'golfPad',
  grint: 'grint',
  localLeague: 'localLeague',
  simpleHandicap: 'simpleHandicap',
  usga: 'usga',
  usHandicap: 'usHandicap',
})

export const appFormProp = ({
  propKey,
  required = true,
  formItemType,
  defaultValue = null,
  opts = {},
}) => {
  return settingsHelpers.newPropObject(
    propKey,
    propDataOpts(required, formItemType, defaultValue, opts)
  );
};
